import { render, staticRenderFns } from "./shoye.vue?vue&type=template&id=7a0096e7&scoped=true"
import script from "./shoye.vue?vue&type=script&lang=js"
export * from "./shoye.vue?vue&type=script&lang=js"
import style0 from "./shoye.vue?vue&type=style&index=0&id=7a0096e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0096e7",
  null
  
)

export default component.exports